import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";
@Component({
  selector: "app-actions-cell",
  template: `<div id="alarmRenderer" title="{{ params.value }}">
    <a
      (click)="openAlarmhistory()"
      style="text-decoration:none; cursor:'pointer'"
      ><div    [style.border-left]="colors ? '8px solid' + colors :  null"
       style="overflow: 'hidden'"
      >
        <span style="padding-left: 10px;">{{ params.value }}</span>
      </div></a
    >
  </div>`,
  styles: [
    `
      #alarmRenderer {
        color: #007bff;
      }
    `,
  ],
})
export class AlarmRendererComponent implements ICellRendererAngularComp {
  public params: any;
  public colors = "";
  public sid = "";
  sname = "";
  scode = "";
  alrPinID = "";
  alarmName = "";
  public link = "";
  agInit(params: any): void {
    let priority = "";
    this.colors = "";
    this.params = params;
    priority = this.params.data.Severity;
    this.sid = this.params.data.SiteID;
    this.scode = this.params.data.siteCode;
    this.sname = this.params.data.sitename;
    this.alrPinID = this.params.data.AlarmPin;
    this.alarmName = this.params.data.alarms;
    if (priority != undefined) {
      if (priority.trim() == "Critical") {
        this.colors = "#E57373";
      } else if (priority.trim() == "Major") {
        this.colors = "#FFB74D";
      } else if (priority.trim() == "Minor") {
        this.colors = "#FFF176";
      }
    }
    this.link = "#/alarmHistory";
    const str =
      '{"siteID":"' +
      this.sid +
      '","sitename":"' +
      this.sname +
      '","siteCode":"' +
      this.scode +
      '","alrPinID":"' +
      this.alrPinID +
      '","alarmName":"' +
      this.alarmName +
      '"}';
    const encr = window.btoa(str);
    this.link = this.link + "?e=" + encr;
  }
  openAlarmhistory() {
    window.open(this.link, "_blank");
  }
  refresh(): boolean {
    return false;
  }
}
